import { render } from "./UsageStatsTable.vue?vue&type=template&id=3541afaa&scoped=true"
import script from "./UsageStatsTable.vue?vue&type=script&lang=js"
export * from "./UsageStatsTable.vue?vue&type=script&lang=js"

import "./UsageStatsTable.vue?vue&type=style&index=0&id=3541afaa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hagino\\work\\src\\plus-manabi\\mplus-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3541afaa"]])

export default __exports__